import { REPORT_GAIN_TYPE_COLUMN_LABEL } from "../../../utils/reports/reportDisplayLabels";

export type FieldColumn = {
  key: string;
  value: string;
  locked?: boolean;
  minWidth?: number;
  align?: "left" | "center" | "right";
};

export const PRIVATE_EQUITY_TABLE_SEGMENT = "PRIVATE_STOCK";

export const PRIVATE_EQUITY_REPORT_TYPE_OPTIONS = [
  { value: "Holding", label: "Unrealized" },
  { value: "Realized", label: "Realized" },
  { value: "All", label: "All" },
  { value: "Transaction", label: "Transaction" },
] as const;

export const PRIVATE_EQUITY_QUICK_REPORTS = [
  { id: "holding", label: "Unrealized", reportType: "Holding" },
  { id: "realized", label: "Realized", reportType: "Realized" },
  { id: "all", label: "All", reportType: "All" },
  { id: "transaction", label: "Transaction Report", reportType: "Transaction" },
];

export const INVESTOR_COLUMN: FieldColumn = {
  key: "investorDisplay",
  value: "Investor Name",
  locked: true,
  minWidth: 200,
};

/** aumsampaan PRIVATE_STOCK Holding preset */
export const PRIVATE_EQUITY_UNREALIZED_HOLDING_COLUMNS: FieldColumn[] = [
  { key: "symbol", value: "Scheme Name", locked: true, minWidth: 200 },
  { key: "purchaseDate", value: "Purchase Date", minWidth: 112 },
  { key: "currentDate", value: "Current Date", minWidth: 112 },
  { key: "units", value: "Qty", minWidth: 100 },
  { key: "averagePrice", value: "Avg. Cost", minWidth: 112 },
  { key: "currentPrice", value: "Current Price", minWidth: 112 },
  { key: "amount", value: "Invested", minWidth: 128 },
  { key: "currentAmount", value: "Current Value", minWidth: 128 },
  { key: "gainLoss", value: "P&L", minWidth: 132 },
  { key: "gainLossPerc", value: "P&L %", minWidth: 96 },
];

export const PRIVATE_EQUITY_REALIZED_COLUMNS: FieldColumn[] = [
  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 200 },
  { key: "type", value: REPORT_GAIN_TYPE_COLUMN_LABEL, locked: true, minWidth: 132 },
  { key: "purchaseDate", value: "Purchase Date", minWidth: 112 },
  { key: "currentDate", value: "Current Date", minWidth: 112 },
  { key: "transactionDate", value: "Date", minWidth: 112 },
  { key: "units", value: "Units Sold", minWidth: 100 },
  { key: "purchaseNAV", value: "Sell Price", minWidth: 112 },
  { key: "avgBuyPrice", value: "Avg Buy Price", minWidth: 112 },
  { key: "saleValue", value: "Sale Value", minWidth: 128 },
  { key: "realisedPnl", value: "Realized P&L", minWidth: 132 },
  { key: "realisedPNLPercentage", value: "Realized P&L%", minWidth: 120 },
];

export const PRIVATE_EQUITY_TRANSACTION_COLUMNS: FieldColumn[] = [
  { key: "transType", value: "Type", locked: true, minWidth: 120 },
  { key: "transactionDate", value: "Date", minWidth: 112 },
  { key: "purchaseDate", value: "Purchase Date", minWidth: 112 },
  { key: "currentDate", value: "Current Date", minWidth: 112 },
  { key: "units", value: "Qty", minWidth: 100 },
  { key: "purchasePrice", value: "Price", minWidth: 112 },
  { key: "currentPrice", value: "Current Price", minWidth: 112 },
  { key: "amount", value: "Amount", minWidth: 128 },
  { key: "currentAmount", value: "Current Value", minWidth: 128 },
];

export const PRIVATE_EQUITY_ALL_COMMON_COLUMNS: FieldColumn[] = [
  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 200 },
  { key: "type", value: REPORT_GAIN_TYPE_COLUMN_LABEL, locked: true, minWidth: 132 },
  { key: "purchaseDate", value: "Purchase Date", minWidth: 112 },
  { key: "currentDate", value: "Current Date", minWidth: 112 },
  { key: "units", value: "Units", minWidth: 100 },
  { key: "costValue", value: "Invested Amount", minWidth: 128 },
  { key: "currentValue", value: "Current Value", minWidth: 128 },
  { key: "gainLoss", value: "P&L", minWidth: 132 },
  { key: "gainLossPercentage", value: "P&L %", minWidth: 96 },
];

export const getColumnsForPrivateEquityReportType = (
  reportType: string,
): FieldColumn[] => {
  switch (reportType) {
    case "Holding":
      return PRIVATE_EQUITY_UNREALIZED_HOLDING_COLUMNS;
    case "Realized":
      return PRIVATE_EQUITY_REALIZED_COLUMNS;
    case "All":
      return PRIVATE_EQUITY_ALL_COMMON_COLUMNS;
    case "Transaction":
      return PRIVATE_EQUITY_TRANSACTION_COLUMNS;
    default:
      return PRIVATE_EQUITY_UNREALIZED_HOLDING_COLUMNS;
  }
};

export const reportTypeNeedsDateRange = (reportType: string): boolean =>
  reportType === "Holding";
